export const version = "2.0-beta (0.10.4-220-gf72e4bbf)";
